/*
 * Polish iban Structure details: https://bank.codes/iban/structure/poland/
 */
const plIbanRegEx =
  /^(\w{0,2})\s*(\w{0,4})\s?(\w{0,4})\s?(\w{0,4})\s?(\w{0,4})\s?(\w{0,4})\s?(\w{0,4})\s?(\w{0,4})/;

const plIbanMask = (input = ''): string => {
  if (input === null) {
    return '';
  }

  const match = plIbanRegEx.exec(input.replace(/\D/g, ''));

  if (!match) {
    return '';
  }

  const accountNum = match
    .slice(1)
    .filter(group => group.length)
    .join(' ');

  return `PL ${accountNum}`;
};

export default plIbanMask;
